import { useEffect, useMemo, useState } from 'react';
import { useCustomInstance } from '../../utils/UseCustomInstance';
import { Pillar2BffRequest } from './executePillar2Filing';
import { fetchPillar2JurisdictionsMetadata, Pillar2JurisdictionMetadata } from './pillar2MetadataBff';

export type Pillar2Jurisdiction = 'AU' | 'CA' | 'GB' | null;

export function resolveJurisdiction(input: string | null | undefined): Pillar2Jurisdiction {
    const normalized = input?.toLowerCase().trim();
    switch (normalized) {
        case 'gb':
        case 'uk':
        case 'united kingdom':
            return 'GB';
        case 'ca':
        case 'canada':
            return 'CA';
        case 'au':
        case 'aus':
        case 'australia':
            return 'AU';
        default:
            return null;
    }
}

export function getJurisdictionBasePath(jurisdiction: Pillar2Jurisdiction): string {
    return `/pillar2/${jurisdiction}`;
}

export function usePillar2Metadata() {
    const bff = useCustomInstance();
    const [metadata, setMetadata] = useState<Pillar2JurisdictionMetadata[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<unknown>(null);

    useEffect(() => {
        let mounted = true;
        setIsLoading(true);
        fetchPillar2JurisdictionsMetadata(bff as Pillar2BffRequest)
            .then((data) => {
                if (mounted) {
                    setMetadata(data);
                    setIsLoading(false);
                }
            })
            .catch((err) => {
                if (mounted) {
                    setError(err);
                    setIsLoading(false);
                }
            });
        return () => {
            mounted = false;
        };
    }, []); // Run once on mount

    return useMemo(() => ({ metadata, isLoading, error }), [metadata, isLoading, error]);
}
